import Twitter from '../../src/legacy/Twitter.tsx';
export default Twitter;
